var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',{staticClass:"main"},[_c(_vm.layout,{tag:"component"}),(_vm.loading)?_c('v-container',{staticClass:"loading d-flex justify-center align-center"},[_c('GifLoading')],1):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }